import { render, staticRenderFns } from "./bool.vue?vue&type=template&id=dcf96a6a"
import script from "./bool.vue?vue&type=script&lang=js"
export * from "./bool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports